
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.657 0C5.124 0 .634 4.48.634 10s4.49 10 10.023 10c5.533 0 10.024-4.48 10.024-10S16.19 0 10.657 0zm0 2c4.43 0 8.019 3.58 8.019 8s-3.588 8-8.019 8c-4.43 0-8.019-3.58-8.019-8s3.589-8 8.02-8zm0 5a3 3 0 100 6 3 3 0 100-6z","fill":"#9B9A9A"}})])
          )
        }
      }
    